export default {
  strict: true,
  namespaced: true,
  state: {
    users: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'modified',
      orderAsc: 0,
      type: 'all',
      isLoading: false,
      status: 'unarchived',
      search: '',
      selectedUser: []
    },
    checked: false,
    enabledDrivers: [],
    initialData: []
  },
  mutations: {
    setCheck (state, value) { state.checked = value },
    setEnabledDrivers (state, value) { state.enabledDrivers = value },
    setInitialData (state, value ) { state.initialData = value },
    resetUsers (state) { state.users.list = [] },
    addUser (state, value) { state.users.list.push(value) },
    setUserMaxList (state, value) { state.users.maxList = value },
    setUserCurrentPage (state, value) { state.users.currentPage = value },
    setUserPerPage (state, value) { state.users.perPage = value },
    setUserOrder (state, value) { state.users.order = value },
    setUserOrderAsc (state, value) { state.users.orderAsc = value },
    setUserType (state, value) { state.users.type = value },
    setUserIsLoading (state, value) { state.users.isLoading = value },
    setUserStatus (state, value) { state.users.status = value },
    setUserSearch (state, value) { state.users.search = value },
    setUserSelected (state, value) { state.users.selectedUser = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/services/enabled-drivers.js